import React, { Fragment, useEffect, useState } from 'react';
import { PackageVisa } from '../ts/PackageResponse';
import {
  Button,
  Checkbox,
  FormGroup,
  Select,
  SelectCustom,
} from '@bepro-travel/fe.ui';
import { PaxModel } from '../ts/PaxModel.tsx';
import {
  BookPayment,
  Credit2000PaymentInfo,
  PhoneInput,
} from '@bepro-travel/fe.shared';
import { paxValidation } from '../constant.tsx';
import { showError, validate } from '@bepro-travel/fe.utils';
import { book, bookAlp, bookComplete } from '../services/visa.tsx';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useGetPage } from '../hooks/useGetPage.ts';
import CancellationPolicyModal from './CancellationModal.tsx';

const BookPage = () => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [pac, setPac] = useState<PackageVisa>();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [pax, setPax] = useState(new PaxModel(0));
  const [paxOptions, setPaxOptions] = useState<Select[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [credit2000PaymentInfo, setCredit2000PaymentInfo] =
    useState<Credit2000PaymentInfo>();
  const [urlParams] = useSearchParams();
  useGetPage('');
  const [showCancellation, setShowCancellation] = useState(false);
  const [stepNumber, setStepNumber] = useState(0);
  const [price, setPrice] = useState('');
  const [useCreditCard, setUseCreditCard] = useState<boolean>();

  const navigate = useNavigate();

  useEffect(() => {
    const selectedPackage = sessionStorage.getItem('selectedPackage');
    if (selectedPackage) {
      const newPac = JSON.parse(selectedPackage) as PackageVisa;

      if (newPac.id !== urlParams.get('id')) return;

      setPrice(newPac.currencySymbol + ' ' + newPac.pricePerPax);
      setPac(newPac);
      setPax(new PaxModel(newPac.minimumPaxesCount));
      const options: Select[] = [];
      for (
        let i = newPac.minimumPaxesCount;
        i <= newPac.minimumPaxesCount + 28;
        i++
      ) {
        options.push({ value: i.toString(), label: i.toString() });
      }
      setPaxOptions(options);
    }
  }, []); // eslint-disable-line

  const onClickSubmit = async () => {
    const isValid = validate(paxValidation, pax);
    setIsSubmitted(true);
    setIsLoading(true);

    if (isValid && termsAccepted) {
      if (sessionStorage.getItem('alpToken')) {
        const data = await bookAlp(
          pax,
          pac?.id!,
          sessionStorage.getItem('alpToken')
        );
        setCredit2000PaymentInfo(data?.data);
        setUseCreditCard(data?.useCreditCard);
      } else {
        const data = await book(pax, pac?.id!);
        setCredit2000PaymentInfo(data?.data);
        setUseCreditCard(data?.useCreditCard);
      }
      setStepNumber(1);
    }

    setIsLoading(false);
  };

  const onClickPay = async (credit: Credit2000PaymentInfo) => {
    if (!validate(paxValidation, pax)) {
      return;
    }
    setIsLoading(true);
    const response = await bookComplete(
      pax,
      pac?.id!,
      true,
      sessionStorage.getItem('alpToken'),
      credit
    );
    setIsLoading(false);
    if (response) {
      if (response?.transactionId) {
        sessionStorage.setItem('orderPayment', JSON.stringify(response));
        navigate('/payment');
      } else if (response.hasErrors) {
        showError(response.errorMessage);
      }
    }
  };

  const onClickSend = async () => {
    if (!validate(paxValidation, pax)) {
      return;
    }
    setIsLoading(true);
    const response = await bookComplete(
      pax,
      pac?.id!,
      false,
      sessionStorage.getItem('alpToken')
    );
    setIsLoading(false);
    if (response) {
      if (response.bookingSuccess) {
        sessionStorage.setItem('orderSuccess', JSON.stringify(response.data));
        navigate('/success');
      } else if (response.hasErrors) {
        showError(response.errorMessage);
      }
    }
  };

  return (
    <div>
      <img
        className="pac-img"
        style={{ height: '60vh' }}
        src={require('../assets/passport.png')}
        alt="1"
      />
      <div className="home-titles">פרטי מזמין</div>

      {!!pac && (
        <div
          className="pac-card-wr display-flex"
          style={{ maxWidth: 1150, margin: '20px auto 0' }}
        >
          <div className="pac-card">
            <div className="title-blue mt-10 mb-10">{pac.productName}</div>
            <div className="mb-10">{pac.productSubName1}</div>
            <div className="mb-20">{pac.productSubName2}</div>
            <div className="mb-10">
              מחיר לאדם {pac.pricePerPax} {pac.currencySymbol}
            </div>
            <div className="pac-card-btn" style={{ height: 35 }}></div>
          </div>
        </div>
      )}

      <div className="pac-wr rtl">
        <div className="book-wr">
          <div className="row">
            {stepNumber === 0 && (
              <Fragment>
                <div
                  className="col-12 mb-20"
                  style={{ color: 'var(--color-danger)' }}
                >
                  'נא למלא שם פרטי ושם משפחה באנגלית כפי שמופיע בדרכון'
                </div>

                <div className="col-12">
                  <FormGroup
                    label="שם פרטי"
                    value={pax.firstName}
                    onChange={(firstName) => setPax({ ...pax, firstName })}
                    validation={paxValidation.firstName}
                    isSubmitted={isSubmitted}
                  />
                </div>
                <div className="col-12">
                  <FormGroup
                    label="שם משפחה"
                    value={pax.lastName}
                    onChange={(lastName) => setPax({ ...pax, lastName })}
                    validation={paxValidation.lastName}
                    isSubmitted={isSubmitted}
                  />
                </div>
                <div className="position-relative w100p">
                  <PhoneInput
                    onChange={(phone) => setPax({ ...pax, phone })}
                    validation={paxValidation.phone}
                    isSubmitted={isSubmitted}
                    value={pax.phone}
                    className="col-12"
                  />
                </div>
                <div className="col-12">
                  <FormGroup
                    label='דוא"ל'
                    value={pax.email}
                    onChange={(email) => setPax({ ...pax, email })}
                    validation={paxValidation.email}
                    isSubmitted={isSubmitted}
                  />
                </div>
                <div className="col-12 mb-20">
                  <div style={{ marginBottom: 5 }}>מספר נוסעים</div>
                  <div>
                    <SelectCustom
                      options={paxOptions}
                      value={pax.passengersCount.toString()}
                      onChange={(passengersCount) =>
                        setPax({ ...pax, passengersCount })
                      }
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div
                    className="checkbox-inline position-relative"
                    style={{ bottom: 10 }}
                  >
                    <Checkbox
                      checked={termsAccepted}
                      onChange={setTermsAccepted}
                      label={'אני מסכים ל'}
                      className=" mt-20"
                      hasError={isSubmitted && !termsAccepted}
                    />
                    <a
                      href="/pages/terms"
                      target="_blank"
                      style={{
                        position: 'relative',
                        top: 2,
                        textDecoration: 'underline',
                      }}
                    >
                      תנאים
                    </a>
                  </div>
                </div>
                <div className="col-6">
                  <Button
                    className={
                      'btn btn-primary w100p' + (isLoading ? ' btn-pulse' : '')
                    }
                    title="המשך"
                    onClick={onClickSubmit}
                    disabled={isLoading}
                  />
                </div>
              </Fragment>
            )}
            {stepNumber === 1 && (
              <Fragment>
                <div className="col-12">
                  <div className="book-item">
                    <span>שם פרטי</span>
                    <span className="line"></span>
                    <span>{pax.firstName}</span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="book-item">
                    <span>שם משפחה</span>
                    <span className="line"></span>
                    <span>{pax.lastName}</span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="book-item">
                    <span>טלפון</span>
                    <span className="line"></span>
                    <span>{pax.phone}</span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="book-item">
                    <span>דוא"ל</span>
                    <span className="line"></span>
                    <span>{pax.email}</span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="book-item">
                    <span>מספר נוסעים</span>
                    <span className="line"></span>
                    <span>{pax.passengersCount}</span>
                  </div>
                </div>
                <div className="col-12">
                  <div className="book-item">
                    <span>מחיר סה"כ</span>
                    <span className="line"></span>
                    <span>{price}</span>
                  </div>
                </div>
                <div className="col-12 btn-back">
                  {useCreditCard === false && (
                    <Button
                      style={{
                        position: 'absolute',
                        right: 0,
                        border: '1px solid var(--color-contrast)',
                      }}
                      className="btn btn-primary btn-lg"
                      title="הזמן"
                      onClick={() => onClickSend()}
                      disabled={isLoading}
                    />
                  )}

                  <Button
                    className="btn btn-default btn-lg"
                    title="חזור"
                    onClick={() => setStepNumber(0)}
                    disabled={isLoading}
                  />
                </div>
              </Fragment>
            )}

            {!!credit2000PaymentInfo && stepNumber === 1 && (
              <div className="col-12">
                <div className="book-payment-wr">
                  <BookPayment
                    onClickSend={onClickSend}
                    onClickSubmit={onClickPay}
                    credit2000={credit2000PaymentInfo}
                    disabled={isLoading}
                    privileges={{
                      bookAllowed: true,
                      proposalAllowed: true,
                      userGroupID: 1,
                      creditCardAllowed: true,
                      agentType: '',
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        {showCancellation && (
          <CancellationPolicyModal onClose={() => setShowCancellation(false)} />
        )}
      </div>
    </div>
  );
};

export default BookPage;
